<template>
  <div class="blackBoard">
    <el-form  label-width="80px" class="search-form" @submit.native.prevent>
      <el-form-item label="运费查询:">
        <el-autocomplete placeholder="请输入地点"
                         v-model="state"
                         :fetch-suggestions="queryArea"
                         @select="selectArea"
                         :trigger-on-focus="false">
          <template slot-scope="{ item }">
            <div class="name">{{ item.value }} <span style="font-size: 12px;color: #9d9d9d">{{ item.address }}</span></div>
          </template>
        </el-autocomplete>
      </el-form-item>
    </el-form>
    <el-tabs editable stretch  type="card" :value="tabIndex.toString()" @tab-click="checkAppCategory" @tab-add="addAppCategory" @tab-remove="removeAppCategory">
      <el-tab-pane v-if="appCategory" v-for="(item, index) in appCategory"  :name="item.categoryId.toString()" :key="item.categoryId">
        <span slot="label">{{item.categoryName}} ({{item.totalOutstanding}}, {{item.totalCompleted}}) <i class="ldms-font ldms-pencil editer" @click.stop.prevent="updateAppCategory(item)"></i></span>
        <div class="wei-tag">
          <el-badge :value="item.totalOutstanding" class="item">
            <el-button size="mini" type="primary" plain >待找车</el-button>
          </el-badge>
          <el-badge :value="item.totalCompleted" class="item">
            <el-button size="mini" type="success" plain>已找车</el-button>
          </el-badge>
          <el-badge  class="item">
              <el-tag @click="toggleSecret" size="medium" type="info" class="iconSize ldms-font ldms-xianshi" ></el-tag>
          </el-badge>
          <el-badge :value="money" class="item">
            <span @mouseout="hindeMoney()">
              <el-tag  @click="showMoney(item.categoryId)" size="medium" class="iconSize ldms-font ldms-yue" ></el-tag>
            </span>
          </el-badge>
          <el-badge  value="微信版" class="item applet">
            <span  @mouseout="hindeApplet()" @mouseover="showApplet()">
              <el-tag size="medium"  type="success" class="iconSize ldms-font ldms-weixin1" ></el-tag>
            </span>
            <div class="appletImg">
              <img width="150" height="150" v-if="applet" src="../../../assets/img/weixin.jpeg" alt="微信小程序">
            </div>
          </el-badge>
          <el-badge  value="快速开单" class="item">
            <el-tag  @click="quite" size="medium" type="warning" class="iconSize ldms-font ldms-heibanblackboard10" ></el-tag>
          </el-badge>
          <el-button @click="showSupplyDialog(item.categoryId, index)" type="primary" icon="el-icon-edit" round style="position: absolute; right: 170px; top: 0px;">新增经理</el-button>
          <el-button @click="showOnself" type="warning"  class="ldms-font ldms-kuloutou" round style="position: absolute; right: 0; top: 0px;">自己上车/合车</el-button>
        </div>
        <el-table
          v-loading="load"
          stripe
          :data="item.supplies"
          :height="windowHeight"
          style="width: 100%;">
          <el-table-column
            label="经理"
            width="150" label-class-name="weiwei" header-align="center">
            <template slot-scope="scope">
              <el-tooltip effect="dark" :open-delay=400 :content="scope.row.contact" placement="top">
                <span class="supplyName" style="margin-left: 10px"  @click="updateSupply(scope.row)" >{{ scope.row.name }} <i class="ldms-font ldms-pencil editer" ></i></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="" label-class-name="weiwei" header-align="center">
            <template slot-scope="scope">
              <div style="display: inline-block" v-for="item in scope.row.publishCargos" :key="item.cargoId">
                <el-tooltip :open-delay=400 v-if="item.remark.length>0" effect="light" placement="top"  :content="item.remark">
                  <el-dropdown size="mini" split-button  @click="showUserOrderDialog(item)" @command="handleCargo" :type="_checkTime(item.startDate) ? 'info' : 'primary'" class="cargo" >
                    <span v-show="item.isShow">不走 </span>
                    <span v-show="!item.isShow" style="text-decoration: underline">{{ item.areaName }} {{item.ton}}</span>
                    <span class="isSecret ldms-font " :class="!item.isShow ? 'ldms-xianshi' : 'ldms-hide'" @click.stop="hiden(item)"></span>
                    <el-dropdown-menu slot="dropdown" >
                      <el-dropdown-item :command="function(){return item}">匹配</el-dropdown-item>
                      <el-dropdown-item :command="item">修改</el-dropdown-item>
                      <el-dropdown-item :command="[item.cargoId,item.supplyId]">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-tooltip>
                <el-dropdown v-else size="mini" split-button @click="showUserOrderDialog(item)" @command="handleCargo" :type="_checkTime(item.startDate) ? 'info' : 'primary'" class="cargo" >
                  <span v-show="item.isShow">不走 </span>
                  <span v-show="!item.isShow">{{ item.areaName }} {{item.ton}}</span>
                  <span class="isSecret ldms-font " :class="!item.isShow ? 'ldms-xianshi' : 'ldms-hide'" @click.stop="hiden(item)"></span>
                  <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item :command="function(){return item}">匹配</el-dropdown-item>
                    <el-dropdown-item :command="item">修改</el-dropdown-item>
                    <el-dropdown-item :command="[item.cargoId,item.supplyId]">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div style="display: inline-block" class="cargo" v-for="item in scope.row.orderUserVos" :key="item.orderId">
                  <el-popover
                    :open-delay=400
                    placement="top-start"
                    width="200"
                    trigger="hover">
                    <div>
                      <ul class="basic-list">
                        <li>运费: <span>{{item.freight+item.priceUnit}}</span></li>
                        <li>找车人: <span>{{item.userName}}</span></li>
                        <li v-if="item.carPhone">电话: <span>{{item.carPhone}}</span></li>
                        <li v-if="item.carNumber">车牌: <span>{{item.carNumber}}</span></li>
                        <li v-if="item.remark">备注: <span>{{item.remark}}</span></li>
                      </ul>
                    </div>
                    <el-dropdown slot="reference" size="mini" split-button @click="showReceiptOrder(item)" @command="handleOrder" type="success">
                      {{ item.areaName }} {{item.ton}}
                      <el-dropdown-menu slot="dropdown" >
                        <el-dropdown-item :command="function(){return item}">匹配</el-dropdown-item>
                        <el-dropdown-item :command="item">修改</el-dropdown-item>
                        <el-dropdown-item :command="[item.orderId,item.cargoId]">删除</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="" fixed="right" width="100px" label-class-name="weiwei" header-align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                plain
                type="success"
                @click="showPublishDialog(scope.row.supplyId, item.categoryId, scope.row.name)">发货</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div v-if="appCategory.length ==0" v-loading="loading">
      <el-table
        stripe
        :height="windowHeight"
        style="width: 100%;">
        <el-table-column
          width="150" label-class-name="weiwei" header-align="center">
        </el-table-column>
        <el-table-column
          label="" label-class-name="weiwei" header-align="center">
        </el-table-column>
        <el-table-column label="" fixed="right" width="100px" label-class-name="weiwei" header-align="center">
        </el-table-column>
      </el-table>
    </div>
    <receipt-order :fold="folds"  :receiptOrder="param" @hiden="folds=false"></receipt-order>
    <order-by-area :slider="slider" :areaInfo="areaInfo" @hiden="slider=false"></order-by-area>
    <el-dialog title="新增经理" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="supplyForm" :rules="rules" ref="supplyForm">
        <el-form-item label="名称" prop="name" label-width="70px">
          <el-input v-model="supplyForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="电话" label-width="70px" prop="contact">
          <el-input v-model="supplyForm.contact" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible=false">取 消</el-button>
        <el-button :loading="publishLoading" type="primary" @click="addSupply('supplyForm')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="取消货源" :visible.sync="dialogDeleteVisible" width="30%">
      <el-checkbox-group v-model="reasonArr" class="reason" @change="reason">
        <el-checkbox label="货主不要" ></el-checkbox>
        <el-checkbox label="司机不拉" ></el-checkbox>
        <el-checkbox label="司机换货" ></el-checkbox>
      </el-checkbox-group>
      <el-form :model="publishForm" :rules="publishRules" ref="deletePublishForm">
        <el-form-item label="取消原因" prop="reason" label-width="80px">
          <el-input v-model.trim="publishForm.reason" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diadeleteCargologDeleteVisible=false">取 消</el-button>
        <el-button type="primary"  :loading="publishLoading" @click="deleteCargo('deletePublishForm')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="取消" :visible.sync="deleteVisible" width="30%">
      <el-checkbox-group v-model="reasonArr" class="reason" @change="reason">
        <el-checkbox label="货主不要" ></el-checkbox>
        <el-checkbox label="司机不拉" ></el-checkbox>
        <el-checkbox label="司机换货" ></el-checkbox>
      </el-checkbox-group>
      <el-form :model="userOrderForm" :rules="userOrderRules" ref="deleteUserOrder">
        <el-form-item label="取消原因" prop="reason" label-width="80px">
          <el-input v-model.trim="userOrderForm.reason" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteVisible=false">取 消</el-button>
        <el-button type="primary"  :loading="publishLoading" @click="deleteUserOrder('deleteUserOrder')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="publishForm.cargoId ? '修改货源' : '发货'" :visible.sync="publishFormVisible" width="30%" size="mini" @open="openPublishForm" >
      <el-form :model="publishForm" :rules="publishRules" ref="publishForm"  label-width="80px">
        <!--<el-form-item label="时间" prop="dateType">-->
          <!--<el-radio-group  size="small" v-model="publishForm.dateType">-->
            <!--<el-radio-button label="1">当日</el-radio-button>-->
            <!--<el-radio-button label="2">明日</el-radio-button>-->
            <!--<el-radio-button label="3">两天以后</el-radio-button>-->
          <!--</el-radio-group>-->
        <!--</el-form-item>-->
        <el-form-item label="发货时间" prop="startDate">
          <el-date-picker
            v-model="publishForm.startDate"
            type="date"
            :picker-options="pickerDate"
            format="yyyy 年 MM 月 dd 日"
            value-format="timestamp"
            @change="changeDate">
          </el-date-picker>
        </el-form-item>
        <autocomplete :areaName.sync="publishForm.areaName" :areaCode="publishForm.areaCode"  :code.sync="publishForm.code" ></autocomplete>
        <el-form-item label="吨位" prop="ton">
          <el-input v-model="publishForm.ton" auto-complete="off" placeholder="请输入吨位">
            <template slot="append">吨</template>
          </el-input>
        </el-form-item>
        <el-form-item label="发货数" size="mini" prop="number" v-if="!publishForm.cargoId">
          <el-input-number v-model="publishForm.number" controls-position="right" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="publishForm.remark" placeholder="对此货源备注的信息"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="publishFormVisible=false">取 消</el-button>
        <el-button :loading="publishLoading" v-if="!publishForm.cargoId" type="primary" @click="addCargo('publishForm')">确 定</el-button>
        <el-button :loading="publishLoading" v-if="publishForm.cargoId" type="primary" @click="updateCargo('publishForm')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="userOrderForm.orderId ? ('修改 ' + publishForm.areaName ): ('上车 ' + publishForm.areaName )" :visible.sync="userOrderFormVisible" width="30%" @open="showUserOrder">
      <el-form :model="userOrderForm" :rules="userOrderRules" ref="userOrderForm"  label-width="80px">
        <el-form-item label="订车运费" prop="freight">
          <el-input type="number" ref="userOrderFormContent" auto-complete="off" placeholder="请输入订车运费" v-model="userOrderForm.freight">
            <el-select slot="append" v-model="userOrderForm.priceUnit" placeholder="请选择" class="unit">
              <el-option label="元/吨" value="元/吨"></el-option>
              <el-option label="元/趟" value="元/趟"></el-option>
              <el-option label="元/箱" value="元/箱"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="车牌号码"  prop="carNumber" class="city-autocomplete">
          <el-autocomplete
            popper-class="my-autocomplete"
            :fetch-suggestions="queryCar"
            placeholder="请输入车牌号码"
            @select="handleSelectCar"
            v-model="userOrderForm.carNumber"
            :trigger-on-focus="false"
          >
            <template slot-scope="{ item }">
              <div class="name" v-if="item.count >0"><i style="color: #d53131">{{ item.carNumber }}</i>&nbsp;<span style="color: #b4b4b4">{{ item.name }}&nbsp;{{item.phone}}</span></div>
              <div class="name" v-else>{{ item.carNumber }}&nbsp;<span style="color: #b4b4b4">{{ item.name }}&nbsp;{{item.phone}}</span></div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="订车电话"  prop="carPhone" class="city-autocomplete">
          <el-autocomplete
            popper-class="my-autocomplete"
            :fetch-suggestions="queryDriver"
            placeholder="请输入订车电话"
            @select="handleSelectDriver"
            v-model="userOrderForm.carPhone"
            :trigger-on-focus="false"
          >
            <template slot-scope="{ item }">
              <div class="name"><i v-if="item.count >0" style="color: #d53131;">{{ item.phone }}({{ item.name }})</i><span v-else>{{ item.phone }}({{ item.name }})</span></div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="userOrderForm.remark" placeholder="对此备注的信息"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="userOrderFormVisible=false">取 消</el-button>
        <el-button :loading="publishLoading" v-if="!userOrderForm.orderId" type="primary" @click="addUserOrder('userOrderForm')">确 定</el-button>
        <el-button :loading="publishLoading" v-if="userOrderForm.orderId" type="primary" @click="updateUserOrder('userOrderForm')">确 定</el-button>
      </div>
    </el-dialog>
    <get-oneself :apps="appId" :show.sync="onself"></get-oneself>
    <quick-page :apps="appId" :show.sync="quitePage"></quick-page>
  </div>
</template>

<script>
import {_queryMapSuggestion} from '../../../utils/area'
import * as Driver from 'driver.js' // import driver.js
import 'driver.js/dist/driver.min.css' // import driver.js css
import steps from './blackBoardSteps'
import { getAppCategory, createAppCategory, updateAppCategory, deleteAppCategory } from '../../../api/appCategory'
import { createSupply, updateSupply } from '../../../api/supply'
import { createCargo, updateCargo, deleteCargo } from '../../../api/publishCargo'
import { createUserOrder, updateUserOrder, deleteUserOrder } from '../../../api/userOrder'
import { getDriverForPhone } from '../../../api/driver'
import { getCarForNumber } from '../../../api/car'
import receiptOrder from '@/components/receiptOrder'
import orderByArea from '@/components/orderByArea'
import autocomplete from '@/components/autocompleteInput'
import getOneself from '@/components/getOneself'
import quickPage from '@/components/quickPage'
import { financeByAllDetail } from '@/api/ordersStatistics'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      applet: false,
      cargList: [],
      money: '',
      publishLoading: false,
      quitePage: false,
      isSecret: false,
      onself: false,
      areaInfo: null,
      timeout: null,
      loading: true,
      load: false,
      folds: false,
      slider: false,
      reasonArr: [],
      windowHeight: '',
      appId: '',
      appCategory: [],
      tabIndex: '',
      currentCategoryIndex: '',
      driver: null,
      dialogFormVisible: false,
      publishFormVisible: false,
      dialogDeleteVisible: false,
      userOrderFormVisible: false,
      deleteVisible: false,
      supplyForm: {
        name: '',
        contact: '',
        categoryId: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
          {min: 2, max: 10, message: '长度在 2 到 10 个字', trigger: 'blur'}
        ],
        contact: [
          {required: true, message: '请输入联系方式', trigger: 'blur'},
          {pattern: /(^0?1[3|4|5|6|9|8|7][0-9]\d{8}$)|(^(\d3,4|\d{3,4}-)?\d{7,8}$)/, message: '电话格式不正确', trigger: ['blur', 'change']},
          {min: 6, max: 15, message: '电话格式不正确', trigger: 'blur'}
        ]
      },
      publishForm: {
        cargoId: '',
        areaName: '',
        supplyId: '',
        ton: '',
        appId: '',
        number: '',
        code: [],
        areaCode: '',
        categoryId: '',
        startDate: '',
        dateType: '',
        remark: '',
        reason: ''
      },
      publishRules: {
        areaName: [
          {required: true, message: '请输入货源信息内容', trigger: 'blur'},
          {min: 2, max: 10, message: '长度在 2 到 10 个字', trigger: 'blur'}
        ],
        ton: [
          {min: 1, max: 5, message: '吨位长度需要在1-5个字之间', trigger: 'blur'}
        ],
        number: [
          {required: true, message: '发货数量最少为1', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '发货地点不可以为空', trigger: 'change'}
        ],
        startDate: [
          {required: true, message: '发货时间不可以为空', trigger: 'change'}
        ],
        remark: [
          {max: 150, message: '备注的长度需要在150个字以内', trigger: 'blur'}
        ],
        reason: [
          {required: true, message: '请输入取消原因', trigger: 'blur'},
          {max: 20, message: '长度需要在20个字以内', trigger: 'blur'}
        ]
      },
      userOrderForm: {
        orderId: '',
        publishCargoId: '',
        priceUnit: '元/吨',
        appId: '',
        freight: '',
        carPhone: '',
        carNumber: '',
        reason: '',
        supplyId: '',
        remark: '',
        isFlagCategory: ''
      },
      userOrderRules: {
        freight: [
          {required: true, message: '订车运费不能为空', trigger: 'blur'}
        ],
        carPhone: [
          {pattern: /^0?1[3|4|5|6|9|8|7][0-9]\d{8}$/, message: '订车电话格式不正确', trigger: ['blur', 'change']}
        ],
        carNumber: [
          {
            pattern: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/,
            message: '车牌号码格式不正确',
            trigger: ['blur', 'change']
          }
        ],
        remark: [
          {max: 150, message: '备注的长度需要在150个字以内', trigger: 'blur'}
        ],
        reason: [
          {required: true, message: '请输入取消原因', trigger: 'blur'},
          {max: 20, message: '长度需要在20个字以内', trigger: 'blur'}
        ]
      },
      param: {},
      pickerDate: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '明天',
          onClick (picker) {
            picker.$emit('pick', new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1, 7).getTime())
          }
        }, {
          text: '后天',
          onClick (picker) {
            picker.$emit('pick', new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 2, 7).getTime())
          }
        }]
      },
      state: ''
    }
  },
  created () {
    this.windowHeight = document.documentElement.offsetHeight - 395
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAppCategory(to.params.id)
      vm.driver = new Driver({
        doneBtnText: '结束',
        closeBtnText: '关闭',
        nextBtnText: '下一步',
        prevBtnText: '上一步'
      })
      vm.driver.defineSteps(steps)
      vm.appId = to.params.id
      vm.setGoEasy(to.params.id)
    })
  },
  computed: {
    ...mapGetters({userInfo: 'user/userInfo'})
  },
  methods: {
    _checkTime (time) {
      let cargoTime = new Date(new Date(time).format('yyyy-MM-dd'))
      let currentTime = new Date(new Date().format('yyyy-MM-dd'))
      return (cargoTime.getTime() - currentTime.getTime() > 0)
    },
    hiden (item) {
      // 从缓存中获取要隐藏的货源
      let cateList = localStorage.getItem('ldms_category_' + this.appId) || '{"item": [], "arrFlag": []}'
      cateList = JSON.parse(cateList)
      let arr = cateList.item
      let arrFlag = cateList.arrFlag
      // 判断是否有属性，没有的话就添加，并把货源隐藏，并且放入到缓存中
      if (typeof(item.isShow) === 'undefined') {
        arr.push(item.cargoId)
        arrFlag.push(!item.isShow)
        this.$set(item, 'isShow', false)
        item.isShow = !item.isShow
      } else {
        // 有属性的话就改变，如果为显示就移除缓存中的数据
        item.isShow = !item.isShow
        let index = arr.indexOf(item.cargoId)
        if (!item.isShow) {
          // 删除属性，使属性为undefined
          delete item.isShow
          arr.splice(index, 1)
          arrFlag.splice(index, 1)
        }
      }
      cateList = {'item': arr, 'arrFlag': arrFlag}
      localStorage.setItem('ldms_category_' + this.appId, JSON.stringify(cateList))
    },
    showApplet () {
      this.applet = true
    },
    hindeApplet () {
      this.applet = false
    },
    showMoney (item) {
      let timer = null
      let _this = this
      let selectForm = {
        appId: this.appId,
        categoryId: [item],
        dateTime: new Date().getTime()
      }
      clearTimeout(timer)
      timer = setTimeout(() => {
        financeByAllDetail(selectForm).then((response) => {
          _this.money = response.data.data.month.totalMoney
        })
      }, 300)
    },
    hindeMoney () {
      this.money = ''
    },
    setGoEasy (appId) {
      let _this = this
      // eslint-disable-next-line
      goEasy.subscribe({
        channel: appId,
        onMessage: function (message) {
          let arr = message.content
          arr = JSON.parse(arr)
          if (arr.isShow == null && _this.userInfo.user.userId !== arr.userId) {
            if (!_this.isSecret) {
              _this.$notify({
                title: arr.title,
                dangerouslyUseHTMLString: true,
                message: `${arr.createDate}，${arr.username}<p>${arr.remark || ''}</p>`,
                position: arr.position
              })
            }
          }
          _this.getAppCategory(appId)
        }
      })
    },
    showReceiptOrder (item) {
      item.appId = this.appId
      this.param = item
      this.folds = true
    },
    showReceiptOrderArea (item) {
      this.areaInfo = item
      this.areaInfo.areaCode = item.adcode || item.areaCode
      this.areaInfo.areaName = item.value || item.areaName
      this.areaInfo.appId = this.appId
      this.slider = true
    },
    showUserOrderDialog (item) {
      this.userOrderFormVisible = true
      this.userOrderForm.publishCargoId = item.cargoId
      this.userOrderForm.areaName = item.areaName
      this.userOrderForm.appId = this.appId
      this.userOrderForm.supplyId = item.supplyId
      this.userOrderForm.supplyName = item.supplyName
      this.userOrderForm.priceUnit = '元/吨'
      this.userOrderForm.freight = ''
      this.userOrderForm.carPhone = ''
      this.userOrderForm.carNumber = ''
      this.userOrderForm.orderId = ''
      this.userOrderForm.remark = item.remark
      this.publishForm.areaName = item.areaName
    },
    deleteUserOrderDialog (item, id) {
      this.deleteVisible = true
      this.userOrderForm.orderId = item
      this.userOrderForm.appId = this.appId
      this.userOrderForm.publishCargoId = id
      this.userOrderForm.reason = ''
      this.reasonArr = []
    },
    handleOrder (command) {
      if (command instanceof Array) {
        this.deleteUserOrderDialog(command[0], command[1])
        return
      }
      switch (typeof command) {
        case 'function':
          this.showReceiptOrderArea(command())
          break
        case 'object':
          this.showUserOrderDialog(command)
          this.userOrderForm.priceUnit = command.priceUnit
          this.userOrderForm.freight = command.freight
          this.userOrderForm.carPhone = command.carPhone
          this.userOrderForm.supplyId = command.supplyId
          this.userOrderForm.orderId = command.orderId
          this.userOrderForm.carNumber = command.carNumber
          break
        case 'number':
          break
      }
    },
    addUserOrder (userOrderForm) {
      let _this = this
      this.publishLoading = true
      this.$refs[userOrderForm].validate((valid) => {
        if (valid) {
          createUserOrder(this.userOrderForm).then((res) => {
            _this.getAppCategory(_this.appId)
            this.userOrderFormVisible = false
            setTimeout(() => {
              _this.publishLoading = false
            }, 1000)
          }).catch(() => {
            _this.publishLoading = false
            _this.userOrderFormVisible = false
          })
        } else {
          this.publishLoading = false
        }
      })
    },
    updateUserOrder (userOrderForm) {
      let _this = this
      this.publishLoading = true
      this.$refs[userOrderForm].validate((valid) => {
        if (valid) {
          updateUserOrder(this.userOrderForm.orderId, this.userOrderForm).then((res) => {
            _this.getAppCategory(_this.appId)
            this.userOrderFormVisible = false
            setTimeout(() => {
              _this.publishLoading = false
            }, 1000)
          }).catch(() => {
            _this.publishLoading = false
            _this.userOrderFormVisible = false
          })
        } else {
          this.publishLoading = false
        }
      })
    },
    deleteUserOrder (deleteUserOrderForm) {
      let _this = this
      this.$refs[deleteUserOrderForm].validateField(['reason'], (valid) => {
        if (!valid) {
          _this.publishLoading = true
          this.$confirm('是否保留原货源?', '提示', {
            confirmButtonText: '保留',
            cancelButtonText: '不保留',
            type: 'warning'
          }).then(() => {
            this.userOrderForm.isFlagCategory = 1
            deleteUserOrder(this.userOrderForm.orderId, this.userOrderForm).then(() => {
              _this.getAppCategory(_this.appId)
              _this.deleteVisible = false
              _this.publishLoading = false
            }).catch(() => {
              _this.deleteVisible = false
              _this.publishLoading = false
            })
          }).catch(() => {
            this.userOrderForm.isFlagCategory = 0
            deleteUserOrder(this.userOrderForm.orderId, this.userOrderForm).then(() => {
              _this.getAppCategory(_this.appId)
              _this.deleteVisible = false
              _this.publishLoading = false
            }).catch(() => {
              _this.deleteVisible = false
              _this.publishLoading = false
            })
          })
        }
      })
    },
    showUserOrder () {
      this.$nextTick(() => {
        this.$refs['userOrderFormContent'].focus()
        this.$refs.userOrderForm.clearValidate()
      })
    },
    checkAppCategory (item) {
      this.setTabIndex(item.name)
      this.tabIndex = item.name
    },
    setTabIndex (id) {
      localStorage.setItem('ldms_tabIndex_' + this.appId, id.toString())
    },
    getTabIndex () {
      return localStorage.getItem('ldms_tabIndex_' + this.appId)
    },
    categoryShow () {
      let cateList = localStorage.getItem('ldms_category_' + this.appId)
      cateList = JSON.parse(cateList)
      if (cateList !== null) {
        let arr = cateList.item
        let arrFlag = cateList.arrFlag
        for (let i = 0; i < this.appCategory.length; i++) {
          for (let j = 0; j < this.appCategory[i].supplies.length; j++) {
            for (let k = 0; k < this.appCategory[i].supplies[j].publishCargos.length; k++) {
              // console.log(this.appCategory[i].supplies[j].publishCargos[k])
              let a = arr.indexOf(this.appCategory[i].supplies[j].publishCargos[k].cargoId)
              if (a > -1) {
                this.$set(this.appCategory[i].supplies[j].publishCargos[k], 'isShow', arrFlag[a])
              }
            }
          }
        }
      }
    },
    reason: function () {
      this.publishForm.reason = this.reasonArr.join()
      this.userOrderForm.reason = this.reasonArr.join()
    },
    guide () {
      this.driver.start()
    },
    resetTemp () {
      this.reasonArr = []
      this.publishForm = {
        cargoId: '',
        areaName: '',
        supplyId: '',
        ton: '',
        appId: '',
        number: '',
        code: [],
        areaCode: '',
        categoryId: '',
        startDate: '',
        dateType: '1',
        remark: '',
        reason: ''
      }
      this.supplyForm = {
        name: '',
        contact: '',
        categoryId: ''
      }
    },
    showPublishDialog (index, categoryId, supplyName) {
      this.publishFormVisible = true
      this.resetTemp()
      this.publishForm.supplyId = index
      this.publishForm.supplyName = supplyName
      this.publishForm.appId = this.appId
      this.publishForm.categoryId = categoryId
      this.publishForm.startDate = new Date()
    },
    showDeleteDialog (id, supplyId) {
      this.resetTemp()
      this.dialogDeleteVisible = true
      this.publishForm.cargoId = id
      this.publishForm.supplyId = supplyId
    },
    handleCargo (command) {
      if (command instanceof Array) {
        this.showDeleteDialog(command[0], command[1])
        return
      }
      switch (typeof command) {
        case 'function':
          this.showReceiptOrderArea(command())
          break
        case 'object':
          this.showPublishDialog(command.supplyId, command.categoryId, command.supplyName)
          command.adcode = command.areaCode
          // this.handleSelect(command)
          this.publishForm.cargoId = command.cargoId
          this.publishForm.areaName = command.areaName
          this.publishForm.ton = command.ton
          this.publishForm.number = 1
          this.publishForm.areaCode = command.areaCode
          this.temcode = command.areaCode
          this.publishForm.startDate = command.startDate
          this.publishForm.dateType = '1'
          this.publishForm.remark = command.remark
          if (new Date().getTime() <= command.startDate) {
            this.publishForm.dateType = '2'
          }
          break
        case 'number':
          break
      }
    },
    openPublishForm () {
      this.$nextTick(() => {
        // this.$refs['publishFormContent'].focus()
        // this.$refs.publishForm.clearValidate()
      })
    },
    addCargo (publishForm) {
      let _this = this
      this.$refs[publishForm].validate((valid) => {
        if (valid) {
          this.publishLoading = true
          this.publishForm.areaCode = this.publishForm.code[this.publishForm.code.length - 1]
          createCargo(this.publishForm).then(() => {
            _this.getAppCategory(_this.appId)
            _this.publishFormVisible = false
            setTimeout(() => {
              _this.publishLoading = false
            }, 1000)
          }).catch(() => {
            _this.publishLoading = false
            _this.publishFormVisible = false
          })
        }
      })
    },
    updateCargo (publishForm) {
      let _this = this
      this.$refs[publishForm].validate((valid) => {
        if (valid) {
          this.publishLoading = true
          this.publishForm.areaCode = this.publishForm.code[this.publishForm.code.length - 1]
          if (this.wei.isNull(this.publishForm.areaCode)) {
            this.publishForm.areaCode = this.temcode
          }
          updateCargo(this.publishForm.cargoId, this.publishForm).then((res) => {
            _this.getAppCategory(_this.appId)
            _this.publishFormVisible = false
            setTimeout(() => {
              _this.publishLoading = false
            }, 1000)
          }).catch(() => {
            _this.publishLoading = false
            _this.publishFormVisible = false
          })
        }
      })
    },
    deleteCargo (deletePublishForm) {
      let _this = this
      this.publishForm.appId = this.appId
      this.$refs[deletePublishForm].validateField(['reason'], (valid) => {
        if (!valid) {
          this.publishLoading = true
          deleteCargo(this.publishForm).then(() => {
            _this.getAppCategory(_this.appId)
            _this.dialogDeleteVisible = false
            setTimeout(() => {
              _this.publishLoading = false
            }, 1000)
          }).catch(() => {
            _this.publishLoading = false
            _this.publishFormVisible = false
          })
        }
      })
    },
    showSupplyDialog (id, index) {
      this.resetTemp()
      this.dialogFormVisible = true
      this.supplyForm.categoryId = id
      this.currentCategoryIndex = index
    },
    addSupply (supplyForm) {
      let _this = this
      this.publishLoading = true
      this.$refs[supplyForm].validate((valid) => {
        if (valid) {
          createSupply(this.appId, this.supplyForm).then((response) => {
            _this.dialogFormVisible = false
            setTimeout(() => {
              _this.publishLoading = false
            }, 1000)
            _this.supplyForm.supplyId = response.data.data.supplyId
            _this.appCategory[_this.currentCategoryIndex].supplies.push(_this.supplyForm)
          }).catch(() => {
            _this.dialogFormVisible = false
            _this.publishLoading = false
          })
        } else {
          this.publishLoading = false
          return false
        }
      })
    },
    updateSupply (supply) {
      this.$prompt('请修改电话', '修改经理', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: supply.contact,
        inputPattern: /^.{3,15}$/,
        inputErrorMessage: '正确格式的电话号码'
      }).then(({value}) => {
        updateSupply(this.appId, supply.supplyId, {
          contact: value,
          categoryId: supply.categoryId,
          name: supply.name
        }).then(() => {
          supply.contact = value
        })
      })
    },
    getAppCategory (appId) {
      this.loading = true
      // this.load = true
      let _this = this
      getAppCategory(appId).then(response => {
        _this.appCategory = response.data.data
        if (_this.appCategory.length === 0) {
          _this.$nextTick(() => {
            _this.guide()
          })
        }
        _this.load = false
        _this.loading = false
        _this.categoryShow()
        _this.tabIndex = _this.getTabIndex() || response.data.data[0].categoryId.toString()
      })
    },
    addAppCategory () {
      let _this = this
      this.$prompt('请输入栏目名称', '新增栏目', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{2,20}$/,
        inputErrorMessage: '长度在2-20位之间'
      }).then(({value}) => {
        createAppCategory({appId: this.appId, categoryName: value}).then((response) => {
          _this.appCategory.push({
            categoryId: response.data.data.categoryId,
            categoryName: value,
            totalCompleted: 0,
            totalOutstanding: 0,
            supplies: []
          })
          _this.tabIndex = response.data.data.categoryId.toString()
          _this.setTabIndex(response.data.data.categoryId)
        })
      })
    },
    updateAppCategory (item) {
      this.$prompt('请输入栏目名称', '修改栏目', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: item.categoryName,
        inputPattern: /^.{2,20}$/,
        inputErrorMessage: '长度在2-20位之间'
      }).then(({value}) => {
        updateAppCategory(item.categoryId, {appId: this.appId, categoryName: value}).then(() => {
          item.categoryName = value
        })
      })
    },
    removeAppCategory (targetName) {
      let _this = this
      this.$confirm('此操作将永久删除该栏目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAppCategory(targetName, _this.appId).then(() => {
          _this.getAppCategory(_this.appId)
          if (_this.appCategory.length > 0) {
            _this.tabIndex = _this.appCategory[0].categoryId.toString()
          }
        })
      })
    },
    queryArea (queryString, cb) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.suggestionArr = _queryMapSuggestion(queryString)
        cb(this.suggestionArr)
      }, 1000)
    },
    selectArea (item) {
      this.showReceiptOrderArea(item)
    },
    queryDriver (queryString, cb) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        getDriverForPhone(queryString).then((response) => {
          if (response.data.data.records.length > 0) {
            cb(response.data.data.records)
          } else {
            // eslint-disable-next-line
            cb([{phone: queryString, name: '陌生号'}])
          }
        })
      }, 600)
    },
    handleSelectDriver (item) {
      this.userOrderForm.carPhone = item.phone
    },
    city (data) {
      this.publishForm.areaName = data.areaName
      this.publishForm.code = data.code
    },
    queryCar (queryString, cb) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        getCarForNumber(queryString, this.appId).then((response) => {
          if (response.data.data.records.length > 0) {
            cb(response.data.data.records)
          } else {
            // eslint-disable-next-line
            cb([{carNumber: queryString, name: ''}])
          }
        })
      }, 600)
    },
    showOnself () {
      this.onself = true
    },
    quite () {
      this.quitePage = true
    },
    handleSelectCar (item) {
      this.userOrderForm.carNumber = item.carNumber
      this.userOrderForm.carPhone = item.phone
    },
    toggleSecret () {
      localStorage.removeItem('ldms_category_' + this.appId)
      this.getAppCategory(this.appId)
      // this.isSecret = !this.isSecret
    },
    changeDate (date) {
      if (new Date(date).getDate() === new Date().getDate()) {
        this.publishForm.startDate = new Date().getTime()
      } else if (new Date(date).getHours() === 0) {
        this.publishForm.startDate = date + 3600000 * 5
      }
    },
    getServerTime () {
      // let xhr = null
      // if (window.XMLHttpRequest) {
      //   xhr = new window.XMLHttpRequest()
      // } else {
      //   xhr = new ActiveObject('Microsoft')
      // }
      // // 通过get的方式请求当前文件
      // xhr.open('get', '/')
      // xhr.send(null)
      // // 监听请求状态变化
      // xhr.onreadystatechange = function () {
      //   let time = null,
      //     curDate = null
      //   if (xhr.readyState === 2) {
      //     // 获取响应头里的时间戳
      //     time = xhr.getResponseHeader('Date')
      //     console.log(xhr.getAllResponseHeaders())
      //     curDate = new Date(time)
      //     console.log(curDate)
      //   }
      // }
    }
  },
  components: {
    receiptOrder,
    orderByArea,
    autocomplete,
    getOneself,
    quickPage
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" >
  .basic-list
    li
      padding 2px
      color #868686
      border-bottom 1px solid rgba(0, 0, 0, 0.06)
      span
        float right
  .unit
    width 85px
    .el-input__icon
      line-height 0
  .reason
    margin 0 0 20px 35px
  .city-autocomplete
    .el-autocomplete
      width 100%
  .my-autocomplete
    li
      line-height: normal
      padding: 7px
      .name
        text-overflow: ellipsis
        overflow: hidden
      .addr
        font-size: 12px
        color: #b4b4b4
      .highlighted
        .addr
          color: #ddd
 .blackBoard
  padding 18px
  background #fff
  border-radius 5px
  transition .3s
  box-shadow 0 0 8px 0 rgba(156, 156, 156, 0.6), 0 2px 4px 0 rgba(232,237,250,0.5)
  .search-form
    width 300px
    margin auto
  .wei-tag
    margin 10px
    .item
      margin-top 10px
      margin-right 40px
  .search
    margin-bottom 10px
  .cargo
    margin-right 15px
    margin-bottom 15px
    .el-button--primary
      color: #03A9F4;
      background: #ecf5ff;
      border-color: #badcff;
      &:before
        background rgb(130, 212, 249)
      &:hover
        background #84cef8
        color #fff
      &:active
        background #5abdf5
      span
        font-weight 700
    .el-button--success
      color: #67c23a;
      background: #f0f9eb;
      border-color: #c2e7b0;
      &:before
        background #67c23a
      &:hover
        background #acdf9c
        color #fff
      &:active
        background #96fd76
      span
        font-weight 700
    .el-button--info
      background-color: #e8e8e8
      border-color: #cccdd0
      color: #676767
      &:before
        background #676767
      &:hover
        background #dedada
        color #fff
      &:active
        background #b1b1b1
  .editer
    border-radius 50%
    font-size 12px
    padding 1px
    &:hover
      color #fff
      background #bdbcbc
  .weiwei
    color #fff
    background-color #00b2ff !important
    text-align center
    padding 2px
  .isSecret
    cursor pointer
    font-size 12px
  .hover-row
    .supplyName
      font-size 20px
      color #000
      font-weight 800
  .applet
    position relative
    .appletImg
      position absolute
      top: 40px
      z-index: 90
      left: -60px;
      width: 150px !important
    .el-badge__content
      background-color: #86ce63 !important
      font-weight: 800
  .iconSize
    font-size: 20px !important;
</style>
